import react from "react";

import Vild1 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_020 Large.jpeg";
import Vild2 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_021 Large.jpeg";
import Vild3 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_022 Large.jpeg";
import Vild4 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_023 Large.jpeg";
import Vild5 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_024 Large.jpeg";
import Vild6 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_025 Large.jpeg";
import Vild7 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_026 Large.jpeg";
import Vild8 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_027 Large.jpeg";
import Vild9 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_028 Large.jpeg";
import Vild10 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_029 Large.jpeg";
import Vild11 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_030 Large.jpeg";
import Vild12 from "../images/commercials/Vild/KIDSPORTFOLIO_WITHBORDERS_2024_031 Large.jpeg";

const Vild = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={Vild1} alt="Vild Kids - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={Vild2} alt="Vild Kids - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={Vild3} alt="Vild Kids - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={Vild4} alt="Vild Kids - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={Vild5} alt="Vild Kids - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={Vild6} alt="Vild Kids - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={Vild7} alt="Vild Kids - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={Vild8} alt="Vild Kids - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={Vild9} alt="Vild Kids - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={Vild10} alt="Vild Kids - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={Vild11} alt="Vild Kids - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={Vild12} alt="Vild Kids - Image 12"/>
                </div>
            </div>
        </div>
    );
}

export default Vild;